module.exports = __webpack_public_path__ + "static/media/tick.95e9dddc.svg";